module.exports = __webpack_public_path__ + "img/Signup-Login.e53a0cfa.svg";